// ----------------------------------------------------------------------
// <copyright file="Izenda.WorkspaceItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Workspace Item component
 */
!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var classnames = require('classnames');
  var constants = require('logic/data/Izenda.CopyManagementConstants');
  var uiState = require('logic/Izenda.UiState');
  var TextHighLight = require('share/components/controls/Izenda.TextHighLight');
  var observer = require('mobx-react').observer;

  var WorkspaceItem = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired,
      dataSource: React.PropTypes.object.isRequired
    },

    onDelete: function(e) {
      var props = this.props;
      var loader = props.loader;

      e.stopPropagation();
      props
        .confirmFn('Confirmation', {
          description: constants.M01
        })
        .then(
          function() {
            loader.startLoading();
            return props.store.deleteWorkspace(props.dataSource).finally(loader.endLoading.bind(loader));
          }.bind(this)
        );
    },

    onSelect: function(e) {
      e.stopPropagation();
      var store = this.props.store;
      var dataSource = this.props.dataSource;

      // Only re-select a current item when it's actually differrent regarding to
      // its id value.
      if (store.item.id != dataSource.id) {
        this.props.confirmDirtyForm(uiState.isDirty, { onConfirmDirtyForm: uiState.onOkDirtyForm }).then(function() {
          store.item = dataSource;
        });
      }
    },

    render: function() {
      var dataSource = this.props.dataSource;
      var selectedId = this.props.store.item.id;
      var filter = this.props.store.filter;

      var selectedClass = classnames('truncate', 'overflow-text', {
        selected: dataSource.id === selectedId
      });

      return (
        <div>
          {/* confirm popup container prevent onclick event in popup to invoke the onSelect*/}
          <div className={selectedClass} onClick={this.onSelect}>
            <TextHighLight
              className='pull-left workspace-name'
              highlight={filter}
              text={dataSource.name}
              tooltip={dataSource.name}
            />
            <span className='icon-cancel white-space-normal' onClick={this.onDelete} />
          </div>
        </div>
      );
    }
  });

  module.exports = observer(connect()(WorkspaceItem));
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceList/Izenda.WorkspaceItem.jsx